export const TOGGLE_SELECTION = 'TOGGLE_SELECTION';
export const CLEAR_SELECTIONS = 'CLEAR_SELECTIONS';
export const SET_CANDIDATE_SELECTION = 'SET_CANDIDATE_SELECTION';

export const SET_UNDO_SELECTIONS = 'SET_UNDO_SELECTIONS';
export const SET_UNDO_STAKE = 'SET_UNDO_STAKE';
export const SET_UNDO_SYSTEMS = 'SET_UNDO_SYSTEMS';
export const SET_UNDO_SELECTIONS_TIMER_ID = 'SET_UNDO_SELECTIONS_TIMER_ID';

export const SET_STAKE = 'SET_STAKE';
export const SET_PURCHASE_TYPE = 'SET_PURCHASE_TYPE';
export const SET_IS_LOADING = 'SET_IS_LOADING';

export const SET_EVENT = 'SET_EVENT';

export const SET_ERROR = 'SET_ERROR';

export const TOGGLE_SYSTEM_SELECTED = 'TOGGLE_SYSTEM_SELECTED';
export const SET_SELECTED_SYSTEMS = 'SET_SELECTED_SYSTEMS';
export const CLEAR_SELECTED_SYSTEMS = 'CLEAR_SELECTED_SYSTEMS';

export const SET_PAYOUT = 'SET_PAYOUT';
// we need this one only when we deserialize betSlip because we don't wanna
// bunch of calculation, only one at the end
export const SET_IS_PAYOUT_LOCKED = 'SET_IS_PAYOUT_LOCKED';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/betSlip/mutationTypes.ts